import { render, staticRenderFns } from "./NewEditLimitation.vue?vue&type=template&id=3f2acf75&"
import script from "../../models/coupon/new-edit-limitation.ts?vue&type=script&lang=ts&"
export * from "../../models/coupon/new-edit-limitation.ts?vue&type=script&lang=ts&"
import style0 from "./NewEditLimitation.vue?vue&type=style&index=0&id=3f2acf75&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports